import { ToastProgrammatic as Toast } from 'buefy';

export default function toastConfirmation(message) {
  Toast.open({
    duration: 5000,
    message: message,
    position: 'is-top',
    type: 'is-success',
  });
}
